const capitals = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
const smalls = 'abcdefghijklmnopqrstuvwxyz'
const numbers = '0123456789'

export const generateRandomString = (length: number): string => {
  const chars = smalls + capitals + numbers

  if (IS_CLIENT_SIDE && (window.crypto || window.msCrypto)) {
    const crypto = window.crypto || window.msCrypto
    const array = crypto.getRandomValues(new Uint8Array(length)).map((x) => chars.charCodeAt(x % chars.length))

    return String.fromCharCode.apply(null, Array.from(array))
  } else {
    // fallback for server side
    let text = ''
    for (let i = 0; i < length; i++) {
      text += chars.charAt(Math.floor(Math.random() * chars.length))
    }
    return text
  }
}

const getHashBuffer = async (data: string): Promise<ArrayBuffer> => {
  const crypto = window.crypto || window.msCrypto
  const isMsCrypto = !window.crypto && !!window.msCrypto

  const msgUint8 = new TextEncoder().encode(data)
  let hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8)
  if (isMsCrypto) {
    // For IE 11 the return type of msCrypto.subtle.digest is different from the standard
    // It returns CryptoOperation instead of Promise
    // We need to access the result differently
    // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
    // @ts-expect-error For IE 11 the return type of msCrypto.subtle.digest is different from the standard
    hashBuffer = hashBuffer.result
  }
  return hashBuffer
}

// As per https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
export const encodeSha256 = async (data: string) => {
  const hashBuffer = await getHashBuffer(data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
  return hashHex
}
